import { Typography } from '@screentone/core';

import styles from './artifact-settings.module.scss';

interface SettingsProps {
  children: React.ReactNode;
  title?: string;
}

export const Settings = ({ children, title = 'Settings' }: SettingsProps) => (
  <div>
    <Typography margin={{ bottom: 'md' }} variant="header3" data-testid="page-settings-title">
      {title}
    </Typography>

    <div className={styles.boxContainer}>{children}</div>
  </div>
);
